import { inject, Pipe, PipeTransform } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { IImageFile, IMAGE_SERVICE } from './image.pipe.model';

const imageCache: Record<string, SafeUrl> = {};

@Pipe({
	name: 'image',
	standalone: true,
})
export class ImagePipe implements PipeTransform {
	private readonly imageService = inject(IMAGE_SERVICE);

	transform(image: IImageFile): Observable<SafeUrl> | Promise<SafeUrl> {
		if (image?.id) {
			if (imageCache[image.id]) {
				return of(imageCache[image.id]);
			}
			return this.imageService.getImageUrl(image.id).pipe(tap((result) => (imageCache[image.id] = result)));
		}
		return Promise.resolve('assets/img/default-placeholder.png');
	}
}
